import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { MbscDatepickerModule, MbscSelectModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    AdminDashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MbscDatepickerModule,
    MbscSelectModule
  ]
})
export class AdminDashboardModule { }
